import React from 'react';

import './EnvironmentWidget.css';


class EnvironmentWidget extends React.Component {
    constructor(props) {
        super(props);
    }

    updateSelection(ev) {
        let anim_dts = this.props['env_data_times'].slice();
        anim_dts.sort((a, b) => a.toMillis() - b.toMillis());

        const new_val = ev.nativeEvent.target.value;
        const new_dt = anim_dts[0].plus({'hours': new_val});
        if (this.props['onenvtimechange'] !== undefined && new_dt.toMillis() != this.props['sel_data_time'].toMillis()) {
            this.props['onenvtimechange'](new_dt);
        }
    }

    animToggle() {
        if (this.props['onanimtoggle'] !== undefined) {
            this.props['onanimtoggle']();
        }
    }

    animSpeedChange(amount) {
        if (this.props['onanimspeedchange'] !== undefined) {
            this.props['onanimspeedchange'](amount);
        }
    }

    layerChange() {
        if (this.props['onenvlayerchange'] !== undefined) {
            const ts_value = document.getElementById('layer-selection').value
            this.props['onenvlayerchange'](ts_value == 'null' ? null : ts_value);
        }
    }

    render() {
        const t_scale = this.props['timeline_taxis'];

        let anim_dts = this.props['env_data_times'].slice();
        anim_dts.sort((a, b) => a.toMillis() - b.toMillis());

        const dx = anim_dts.length < 2 ? 0 : t_scale.map(anim_dts[1]) - t_scale.map(anim_dts[0]);
        const left = anim_dts.length < 1 ? 0 : t_scale.map(anim_dts[0]);

        let marker_display;
        const marker_display_cls = this.props['right'] - this.props['left'] > 500 ? '' : 'mobile';

        if (this.props['sel_data_time'] !== null && this.props['interval'].duration() <= this.props['env_intv_dur_cutoff']) {
            const val = this.props['sel_data_time'].diff(anim_dts[0], 'hours').toObject()['hours'];
            marker_display = <input id='t-slider' type="range"
                                style={{'left': (left - 9) + 'px', 'width' : (dx * (anim_dts.length - 1) + 19) + 'px'}}
                                min="0" max={anim_dts.length - 1} step="1" value={val} onChange={this.updateSelection.bind(this)}/>
        }
        else if (this.props['interval'].duration() > this.props['env_intv_dur_cutoff']) {
            marker_display = <div id='env-message'>
                                Select an interval shorter than {this.props['env_intv_dur_cutoff'].hours} hrs to display environment data
                            </div>
        }
        else {
            marker_display = <div id='env-message'>
                                No environment data available
                            </div>
        }

        let playpause_class = this.props['is_animating'] ? 'active' : '';
        let button_class = '';
        let playpause_click = this.animToggle.bind(this);
        let animspdup_click = () => this.animSpeedChange(1);
        let animspddn_click = () => this.animSpeedChange(-1);

        if (this.props['env_data_times'].length == 0) {
            playpause_class = 'disabled';
            button_class = 'disabled';
            playpause_click = () => {};
            animspdup_click = () => {};
            animspddn_click = () => {};
        }

        return (
            <div id='env-controls'>
                <div id='layer-controls'>
                    <select id='layer-selection'
                        onChange={this.layerChange.bind(this)}
                        defaultValue={this.props['env_type']}>
                        <option value='null'>None</option>
                        {this.props['env_handler'].getAvailableReanalyses().map(rea => {
                            return (
                                <optgroup key={rea} label={rea}>
                                    {this.props['env_handler'].getAvailableTypes().map(typ => {
                                    return (
                                        <option key={rea + '-' + typ} value={typ}>
                                            {this.props['env_handler'].getDropdownEntry(typ)}
                                        </option>);
                                    })}
                                </optgroup>
                            )
                        })}
                    </select>
                </div>
                <div id='anim-controls'>
                    <div id='playpause'
                        className={playpause_class}
                        onClick={playpause_click}>&#9654;&#xfe0e;&#9616;&#9616;
                    </div>
                    <div
                        className={button_class}
                        onClick={animspddn_click}>-</div>
                    <div
                        className={button_class}
                        onClick={animspdup_click}>+</div>
                </div>
                <div id='marker-display' className={marker_display_cls}>
                    {marker_display}
                </div>
            </div>
        )
    }
}

export default EnvironmentWidget;